import Careers from "../components/sections/Careers";
import { motion } from "framer-motion";
import useSEO from "../lib/useSEO";

export default function CareersPage() {
    useSEO({
        title: "Careers at Thooyra Technologies — Software Engineering Jobs in Chennai",
        description:
            "Join Thooyra Technologies in Chennai. We are always looking for engineers, builders and problem solvers passionate about modern business software.",
        path: "/careers",
    });
    return (
        <main data-testid="careers-page">
            <section className="relative pt-36 pb-4 md:pt-44 overflow-hidden">
                <div
                    aria-hidden
                    className="absolute inset-0 -z-10 pointer-events-none"
                >
                    <div className="absolute top-0 left-1/3 w-[420px] h-[420px] rounded-full bg-blue-300/30 dark:bg-blue-500/20 blur-[120px] animate-blob" />
                </div>
                <div className="max-w-7xl mx-auto px-6 md:px-12">
                    <motion.div
                        initial={{ opacity: 0, y: 14 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <div className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
                            Careers
                        </div>
                        <h1 className="font-display font-light text-5xl md:text-7xl tracking-tighter leading-[1.02] max-w-4xl">
                            Come build the future of{" "}
                            <span className="italic font-medium">
                                business software
                            </span>{" "}
                            with us.
                        </h1>
                    </motion.div>
                </div>
            </section>
            <Careers />
        </main>
    );
}
